module.exports = __webpack_public_path__ + "img/slide_2.cb6f9345.jpg";